import { Link } from 'react-router-dom';

export default function AboutHero() {
  return (
    <section className="relative min-h-[85vh] flex items-end overflow-hidden" style={{ paddingTop: '108px' }}>

      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/7dc46b24c5eff97449abb4f0645dbbb3.jpg')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-t from-ecos-charcoal/95 via-ecos-charcoal/55 to-ecos-charcoal/25"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-ecos-charcoal/40 to-transparent"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 pb-20 pt-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <Link to="/" className="text-white/40 hover:text-white text-xs transition-colors cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line text-white/25 text-xs"></i>
            <span className="text-ecos-green text-xs font-medium">About Us</span>
          </div>
          <div className="inline-flex items-center gap-3 bg-ecos-green/20 border border-ecos-green/40 px-4 py-2 rounded-sm mb-8">
            <div className="w-1.5 h-1.5 bg-ecos-green rounded-full"></div>
            <span className="text-ecos-green text-xs font-semibold tracking-widest uppercase">25+ Years of Certified Service</span>
          </div>
          <h1 className="font-serif text-white font-semibold leading-tight mb-6" style={{ fontSize: 'clamp(2.8rem, 5vw, 4.5rem)' }}>
            Environmental Expertise<br />You Can{' '}
            <em className="not-italic text-ecos-gold">Trust.</em>
          </h1>
          <p className="text-white/60 text-lg leading-relaxed max-w-xl">
            Colorado&apos;s premier environmental remediation and disaster restoration specialists. Certified professionals, rigorous compliance, and a track record that speaks for itself.
          </p>
        </div>
      </div>

    </section>
  );
}
